import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../text-input/TextInput';
import DatePickerButton from '../datepicker-button/DatePickerButton';
import CommonAppSetup from '../../../common/common-app-setup/CommonAppSetup';
import moment from 'moment';
import Components from '../../../common/Components';
import joinClassNames from "../../../common/JoinClassNames";
import MaskType from "../../../common/masking/MaskType";
import DirtyEngine from "../../../common/dirty/DirtyEngine";
import ValidationEngine from "../../../common/validation/ValidationEngine";
import ChildPosition from "../ChildPosition";

// see TextInput.propTypes for additional propTypes
// see DatePicker for additional propTypes
const propTypes = {
	// css classes (pass though to TextInput / Date Picker
	className: PropTypes.string,

	// tracks dirty state of fields
	dirtyEngine: PropTypes.instanceOf(DirtyEngine),

	// An error message to show. Overrides validation errors.
	errorMessage: PropTypes.string,

	// the name of the redux field being edited and id of the input for label. for=
	field: PropTypes.string.isRequired,

	// A function that returns an icon, usually an svg icon to show. Can be any element, however
	icon: PropTypes.func,

	// is this input "dirty" - trumps DirtyEngine
	isDirty: PropTypes.bool,

	// maxDate - moment object -- react-datepicker

	// minDate - moment object -- react-datepicker

	// what function to trigger when a change is detected (could be a dispatcher); parameters: field, value
	onChange: PropTypes.func,

	// Options for the calendar popup -- react-datepicker
	popperModifiers: PropTypes.object,

	// Placement of the calendar popup -- react-datepicker
	popperPlacement: PropTypes.string,

	// When the component mounts should the input be given focus.
	// passthrough prop
	setInitialFocus: PropTypes.bool,

	// If you don't provide an icon you can prevent display of the default icon.
	showDefaultIcon: PropTypes.bool,

	// Show the "Choose" text on the calendar picker button
	showText: PropTypes.bool,

	// the validation rules and results
	validationEngine: PropTypes.instanceOf(ValidationEngine),

	// the value of this field: must be a valid date string that can be parsed by javascript Date
	value: PropTypes.string,
};

const defaultProps = {
	className: undefined,
	dirtyEngine: undefined,
	errorMessage: undefined,
	icon: undefined,
	isDirty: undefined,
	onChange: undefined,
	popperModifiers: {
		offset: {
			enabled: true,
			offset: '50px, 0'
		},
	},
	popperPlacement: "bottom-end",
	setInitialFocus: false,
	showDefaultIcon: true,
	showText: false,
	validationEngine: new ValidationEngine(),
	value: undefined,
};

// What happens when there is a conflict of propType names used in both the TextInput and the DatePicker?

const dateFormat = 'MM/DD/YYYY';

export default class CalendarInput extends React.Component {
	constructor(props) {
		super(props);
		this.dirtyEngine = this.props.dirtyEngine ? this.props.dirtyEngine : new DirtyEngine({[this.props.field]: this.props.value});
	}

	render() {
		let {
			className,
			dirtyEngine,
			errorMessage,
			icon,
			isDirty,
			maxDate,
			minDate,
			onChange,
			popperModifiers,
			popperPlacement,
			showDefaultIcon,
			showText,
			validationEngine,
			value,
			...passThroughProps
		} = this.props;

		let momentVal = moment(value, dateFormat);
		momentVal = momentVal.isValid() ? momentVal : undefined;
		return (
			<TextInput
				children={
					<DatePickerButton
						icon={icon}
						maxDate={maxDate}
						minDate={minDate}
						onChange={momentVal => {
							onChange(this.props.field, momentVal.format(dateFormat));
						}}
						popperModifiers={popperModifiers}
						popperPlacement={popperPlacement}
						selected={momentVal}
						showDefaultIcon={showDefaultIcon}
						showText={showText}
						{...passThroughProps}
					/>
				}
				childrenPosition={ChildPosition.AFTER}
				className={joinClassNames(
					"calendar-input__wrapper",
					className,
					CommonAppSetup.getClassName(Components.CALENDAR_INPUT, 'wrapper'),
				)}
				dirtyEngine={this.dirtyEngine}
				errorMessage={errorMessage}
				isDirty={this.dirtyEngine.isDirty({[this.props.field]: this.props.value}, this.props.field, isDirty)}
				maskType={MaskType.DATE}
				minDate={minDate ? minDate.format(dateFormat) : undefined}
				maxDate={maxDate ? maxDate.format(dateFormat) : undefined}
				onChange={onChange}
				validationEngine={validationEngine}
				value={value}
				{...passThroughProps}
			/>
		);
	}
}

CalendarInput.propTypes = propTypes;
CalendarInput.defaultProps = defaultProps;